import { InjectionKey, Ref } from 'vue';

export const FieldLabelIdInjectionKey = Symbol('fieldLabelId') as InjectionKey<Ref<string | null>>;
